const getDoubleDigit = (time: string | number) => {
  time = time.toString();
  if (time.length < 2) return '0' + time;
  else return time;
};

const toIDString = (date: Date) => {
  return `${getDoubleDigit(date.getDate())}-${getDoubleDigit(
    date.getMonth() + 1
  )}-${getDoubleDigit(date.getFullYear())}`;
};

export const toIDStringWithHours = (date: Date, withoutSec?: boolean) => {
  if (withoutSec) {
    return `${toIDString(date)} ${getDoubleDigit(
      date.getHours()
    )}:${getDoubleDigit(date.getMinutes())}`;
  }

  return `${toIDString(date)} ${getDoubleDigit(
    date.getHours()
  )}:${getDoubleDigit(date.getMinutes())}:${getDoubleDigit(date.getSeconds())}`;
};

export const toKRString = (date: Date) => {
  return `${date.getFullYear()}-${getDoubleDigit(
    date.getMonth() + 1
  )}-${getDoubleDigit(date.getDate())}`;
};

export const isValidDateString = (dateString: string) => {
  const date = Date.parse(dateString);
  return !isNaN(date);
};

export const getIDRelativeTime = (
  diff: number,
  unit: Intl.RelativeTimeFormatUnit
) => {
  return new Intl.RelativeTimeFormat('id-ID').format(diff, unit);
};

export default toIDString;
